$('.in-index .products').each(function () {
  const $carousel = $(this);
  const $closestTitle = $carousel.prev('.homepage-group-title');
  $carousel.slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    infinite: true,
    adaptiveHeight: false,
    appendArrows: $closestTitle,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,

          dots: true,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        }
      },
      {
        breakpoint: 991,
        settings: {
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 2.2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1.9,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 330,
        settings: {
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1.4,
          slidesToScroll: 1,
        }
      }
    ]
  });
});


$('.in-index .referencesFeed').each(function () {
  const $carousel = $(this);
  const $closestTitle = $carousel.prev('.homepage-group-title');
  $carousel.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    infinite: true,
    adaptiveHeight: false,
    appendArrows: $closestTitle,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          speed: 300,
          infinite: false,
          adaptiveHeight: true,
          slidesToShow: 2.2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          speed: 300,
          infinite: false,
          adaptiveHeight: true,
          slidesToShow: 1.2,
          slidesToScroll: 1,
        }
      }
    ]
  });
});



$(document).ready(function () {
  const $firmsFeed = $('.in-index .firmsFeed');
  const $closestTitleFirmsLogo = $('.in-index .firmsFeed').prev('.homepage-group-title');

  function initSlick() {
    if (!$firmsFeed.hasClass('slick-initialized')) {
      $firmsFeed.slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        appendArrows: $closestTitleFirmsLogo,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              appendArrows: $closestTitleFirmsLogo,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3.1,
              slidesToScroll: 1,
              appendArrows: $closestTitleFirmsLogo,
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2.1,
              slidesToScroll: 1,
              appendArrows: $closestTitleFirmsLogo,
            }
          }
        ]
      });
    }
  }

  function checkSlick() {
    if ($(window).width() >= 1200) {
      if ($firmsFeed.hasClass('slick-initialized')) {
        $firmsFeed.slick('unslick');
      }
    } else {
      initSlick();
    }
  }

  // Initial check
  checkSlick();

  // Resize event
  $(window).on('resize', function () {
    checkSlick();
  });
});

$('.ourTeaFeed').slick({
  arrows: false,
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [

    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
      }
    }
  ]
});




$(".type-post .plus-gallery-wrap").slick({
  mobileFirst: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: false,
  dots: false,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
